
import { PALETA_CLARA, cor } from "../../../../styles/theme/paletaCores";

export const CORES_GRAFICO = PALETA_CLARA;

export const AZUL = cor("azul");
export const NAVY = cor("navy");
export const AZUL_FUNDO = cor("azulFundo");
export const NAVY_FUNDO = cor("navyFundo");
export const BORDA = cor("borda");
export const SUAVE = cor("suave");
export const FUNDO_SUAVE = cor("fundoSuave");

export const TEXTO_TABELA = cor("textoTabela");
export const CINZA_BOTAO = cor("cinzaBotao");
export const ABA_INATIVA = cor("abaInativa");
export const BORDA_ABA = cor("bordaAba");
export const FUNDO_BLOCO = cor("fundoBloco");
export const FUNDO_DESTAQUE = cor("fundoDestaque");
export const BORDA_DESTAQUE = cor("bordaDestaque");
export const FUNDO_CARTAO_PAGAMENTO = BORDA;
export const FUNDO_CARTAO = cor("fundoCartao");
export const TEXTO_SOBRE_COR = cor("textoSobreCor");
export const ERRO_TEXTO = cor("erroTexto");
export const ERRO_FUNDO = cor("erroFundo");
export const ERRO_BORDA = cor("erroBorda");

export const VERDE_TEXTO = cor("verdeTexto");
export const VERDE_FUNDO = cor("verdeFundo");
export const VERMELHO_TEXTO = cor("vermelhoTexto");
export const VERMELHO_FUNDO = cor("vermelhoFundo");
export const AMBAR_TEXTO = cor("ambarTexto");
export const AMBAR_FUNDO = cor("ambarFundo");
export const ETIQUETA_VERDE_TEXTO = cor("etiquetaVerdeTexto");
export const ETIQUETA_VERDE_FUNDO = cor("etiquetaVerdeFundo");
export const ETIQUETA_VERMELHO_TEXTO = cor("etiquetaVermelhoTexto");
export const ETIQUETA_VERMELHO_FUNDO = cor("etiquetaVermelhoFundo");
export const ETIQUETA_AMARELO_TEXTO = cor("etiquetaAmareloTexto");
export const ETIQUETA_AMARELO_FUNDO = cor("etiquetaAmareloFundo");
export const ALERTA_FUNDO = cor("alertaFundo");
export const ALERTA_BORDA = cor("alertaBorda");
export const ETIQUETA_CINZA_TEXTO = cor("etiquetaCinzaTexto");
export const ETIQUETA_CINZA_FUNDO = cor("etiquetaCinzaFundo");
export const ETIQUETA_ARDOSIA_TEXTO = cor("etiquetaArdosiaTexto");
export const ETIQUETA_ARDOSIA_FUNDO = cor("etiquetaArdosiaFundo");
export const AZUL_CLARO_ANTERIOR = cor("azulClaroAnterior");
export const VERDE_VARIACAO = cor("verdeVariacao");
export const VERMELHO_VARIACAO = cor("vermelhoVariacao");
export const AMARELO_PARTICIPACAO = cor("amareloParticipacao");
export const TRILHO_PARTICIPACAO = cor("trilhoParticipacao");

export const MEDIDAS_INDICADOR = {
  padding: "26px 28px 22px",
  raio: 10,
  titulo: 14,
  valor: "clamp(21px, 1.4vw, 25px)",
  detalhe: 16,
  tituloCartao: "clamp(19px, 1.3vw, 22px)",
  nomeOperadora: 17,
  valorOperadora: 15,
};
export const GRADE_GRAFICO = cor("gradeGrafico");
export const FUNDO_REGISTRO_PAY = cor("fundoRegistroPay");
export const SELO_REGISTRO_PAY = cor("seloRegistroPay");

export const FONTE = ["Inter", "Roboto", "Segoe UI", "Helvetica Neue", "Arial", "sans-serif"].join(",");

export const estilos = {
  cartao: {
    border: `1px solid ${BORDA}`,
    borderRadius: 16,
    background: FUNDO_CARTAO,
    boxSizing: "border-box" as "border-box",
    height: "100%",
  },
  filtro: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    border: `1px solid ${BORDA}`,
    borderRadius: 30,
    padding: "7px 7px 7px 16px",
    gap: 10,
    background: FUNDO_CARTAO,
    minWidth: 0,
  },
  filtroRotulo: {
    fontFamily: FONTE,
    fontSize: "clamp(12px, 0.9vw, 14px)",
    fontWeight: 500,
    color: SUAVE,
    textTransform: "uppercase" as "uppercase",
    letterSpacing: 0.5,
    whiteSpace: "nowrap" as "nowrap",
    flexShrink: 0,
  },
  filtroValor: {
    display: "flex",
    alignItems: "center",
    gap: 5,
    background: AZUL_FUNDO,
    color: TEXTO_SOBRE_COR,
    borderRadius: 26,
    padding: "7px 10px 7px 16px",
    fontFamily: FONTE,
    fontSize: "clamp(13px, 1vw, 16px)",
    fontWeight: 500,
    whiteSpace: "nowrap" as "nowrap",
    minWidth: 0,
  },
  textoAjudaIndicador: {
    display: "block",
    fontFamily: FONTE,
    fontSize: "clamp(13px, 0.9vw, 16px)",
    fontWeight: 400,
    lineHeight: 1.45,
    padding: "4px 2px",
    maxWidth: 300,
  },
  indicadorTitulo: {
    fontFamily: FONTE,
    fontSize: MEDIDAS_INDICADOR.titulo,
    fontWeight: 500,
    color: SUAVE,
    textTransform: "uppercase" as "uppercase",
    letterSpacing: 0.4,
    marginBottom: 18,
  },
  indicadorValor: {
    display: "flex",
    alignItems: "baseline",
    gap: 5,
    fontFamily: FONTE,
    fontSize: MEDIDAS_INDICADOR.valor,
    fontWeight: 700,
    color: NAVY,
    lineHeight: 1.3,
    whiteSpace: "nowrap" as "nowrap",
  },
  indicadorSigla: {
    fontSize: "clamp(13px, 2vw, 17px)",
    fontWeight: 500,
    color: SUAVE,
  },
  resumoRotulo: {
    fontFamily: FONTE,
    fontSize: "clamp(15px, 2.3vw, 19px)",
    fontWeight: 500,
    color: AZUL,
    marginBottom: 8,
  },
  resumoValor: {
    fontFamily: FONTE,
    fontSize: "clamp(22px, 3.6vw, 31px)",
    fontWeight: 700,
    color: NAVY,
    whiteSpace: "nowrap" as "nowrap",
  },
  tituloCartao: {
    fontFamily: FONTE,
    fontSize: MEDIDAS_INDICADOR.tituloCartao,
    fontWeight: 700,
    color: NAVY,
    padding: "clamp(16px, 2.2vw, 26px) clamp(16px, 2.5vw, 30px) 0",
  },
  legendaNome: {
    fontFamily: FONTE,
    fontSize: MEDIDAS_INDICADOR.nomeOperadora,
    fontWeight: 500,
    color: NAVY,
    whiteSpace: "normal" as "normal",
    overflow: "hidden" as "hidden",
    overflowWrap: "anywhere" as "anywhere",
    lineHeight: 1.25,
  },
  legendaValor: {
    fontFamily: FONTE,
    fontSize: MEDIDAS_INDICADOR.valorOperadora,
    fontWeight: 700,
    color: NAVY,
    whiteSpace: "nowrap" as "nowrap",
    flexShrink: 0,
  },
  legendaPercentual: {
    fontFamily: FONTE,
    fontSize: MEDIDAS_INDICADOR.valorOperadora,
    fontWeight: 500,
    color: SUAVE,
    minWidth: 52,
    textAlign: "right" as "right",
    flexShrink: 0,
  },
  semDados: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    minHeight: 220,
    padding: "0 16px",
    textAlign: "center" as "center",
    fontFamily: FONTE,
    fontSize: 16,
    fontWeight: 500,
    color: SUAVE,
  },
  rodapeDetalhes: {
    display: "flex",
    justifyContent: "center",
    padding: "8px 0 20px",
  },
  botaoDetalhes: {
    display: "flex",
    alignItems: "center",
    gap: 6,
    background: AZUL_FUNDO,
    color: TEXTO_SOBRE_COR,
    borderRadius: 26,
    padding: "8px 22px 8px 16px",
    boxShadow: "0 2px 6px rgba(0, 0, 0, 0.18)",
    cursor: "pointer",
    userSelect: "none" as "none",
  },
  rodapeDetalhesTexto: {
    fontFamily: FONTE,
    fontSize: "clamp(15px, 2.2vw, 18px)",
    fontWeight: 700,
  },
};
